import { HTMLMotionProps, motion } from 'framer-motion';
import { omit } from 'lodash';
import { forwardRef } from 'react';

const _DiaryShortsAnimatePresenceDiv = forwardRef<
  HTMLDivElement,
  HTMLMotionProps<'div'>
>((props, ref) => {
  return (
    <motion.div
      {...omit(props, ['children'])}
      ref={ref}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {props.children}
    </motion.div>
  );
});

export default _DiaryShortsAnimatePresenceDiv;
